import React from "react";
import { T, Btn } from "../shared/UI";
import { useApp } from "../../store/AppContext";

const VIEW_TITLES = {
  map:     "Live Tracking Map",
  agents:  "Agent Management",
  alerts:  "Alert Center",
  history: "Play History",
  "visits-map": "Agent Visits Map",
  reports: "Reports & Analytics",
  "agent-attendance": "Agent Attendance Report",
  products:"Products",
  users:   "User Management",
  "app-alerts": "App Alerts",
};

export default function Header({ activeAgents, idleAgents, offlineAgents, activeAlerts, user, onLogout }) {
  const { view, openAlertModal, theme, setTheme, toggleSidebarMobile } = useApp();

  return (
    <header style={styles.header}>
      <button className="menu-btn" style={styles.menuBtn} onClick={toggleSidebarMobile} aria-label="Toggle menu">
        ☰
      </button>
      <div>
        <div className="header-title" style={styles.title}>{VIEW_TITLES[view] || "Dashboard"}</div>
        <div className="header-sub" style={styles.sub}>Real-time agent operations console</div>
      </div>

      {/* Fleet stats */}
      <div className="header-stats" style={styles.stats}>
        {[
          { dot:"#6af7c4", label:"Active",  val: activeAgents  },
          { dot:"#f7c46a", label:"Idle",    val: idleAgents    },
          { dot:"#4d6680", label:"Offline", val: offlineAgents },
        ].map(s => (
          <div key={s.label} style={styles.stat}>
            <div style={{ ...styles.dot, background:s.dot }} />
            <span style={{ color:T.muted, fontSize:12 }}>{s.label}</span>
            <strong style={{ color:T.text, fontSize:13, fontFamily:T.fontMono }}>{s.val}</strong>
          </div>
        ))}
      </div>

      <div style={{ display:"flex", alignItems:"center", gap:10, marginLeft:"auto" }}>
        <div style={styles.livePill}>
          <div style={styles.liveDot} />
          LIVE
        </div>
        <button
          style={styles.themeBtn}
          onClick={() => setTheme(theme === "light" ? "dark" : "light")}
          title={`Switch to ${theme === "light" ? "Dark" : "Light"} mode`}
        >
          {theme === "light" ? "🌙 Dark" : "☀ Light"}
        </button>
        <Btn variant="danger" size="sm" icon="🚨" onClick={() => openAlertModal(null)}>
          Broadcast
        </Btn>

        {/* User info + logout */}
        {user && (
          <div style={styles.userBadge}>
            <div style={styles.userAvatar}>
              {(user.fullName || "A").split(" ").map(n=>n[0]).join("").toUpperCase().slice(0,2)}
            </div>
            <div style={styles.userInfo}>
              <div style={styles.userName}>{user.fullName}</div>
              <div style={styles.userRole}>{user.role}</div>
            </div>
            <button style={styles.logoutBtn} onClick={onLogout} title="Sign out">
              ⏻
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

const styles = {
  header:    { height:60, background:T.s1, borderBottom:`1px solid ${T.border}`, display:"flex", alignItems:"center", padding:"0 20px", gap:16, flexShrink:0 },
  menuBtn:   { display:"none", background:"none", border:"none", color:T.text, fontSize:20, cursor:"pointer", padding:"8px", borderRadius:6, transition:"all 0.18s" },
  title:     { fontSize:15, fontWeight:700, color:T.text, lineHeight:1.2 },
  sub:       { fontSize:11, color:T.muted },
  stats:     { display:"flex", gap:18, marginLeft:20 },
  stat:      { display:"flex", alignItems:"center", gap:6, fontFamily:T.fontMono, fontSize:12 },
  dot:       { width:7, height:7, borderRadius:"50%" },
  livePill:  { display:"flex", alignItems:"center", gap:5, background:"rgba(106,247,196,0.08)", border:"1px solid rgba(106,247,196,0.2)", borderRadius:20, padding:"4px 10px", fontFamily:T.fontMono, fontSize:10, color:T.acc3, letterSpacing:1 },
  liveDot:   { width:6, height:6, borderRadius:"50%", background:T.acc3, animation:"pulse 1.5s infinite" },
  themeBtn:  { background:T.s2, border:`1px solid ${T.border2}`, color:T.text, borderRadius:8, padding:"6px 10px", fontFamily:T.fontMono, fontSize:10, cursor:"pointer" },
  userBadge: { display:"flex", alignItems:"center", gap:8, background:T.s2, border:`1px solid ${T.border2}`, borderRadius:10, padding:"5px 10px 5px 5px" },
  userAvatar:{ width:30, height:30, borderRadius:8, background:`linear-gradient(135deg, ${T.acc}, ${T.acc2})`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700, color:"#fff", fontFamily:T.fontMono, flexShrink:0 },
  userInfo:  { display:"flex", flexDirection:"column" },
  userName:  { fontSize:12, fontWeight:600, color:T.text, lineHeight:1.2 },
  userRole:  { fontSize:10, color:T.muted, fontFamily:T.fontMono, letterSpacing:"0.5px" },
  logoutBtn: { background:"none", border:`1px solid ${T.border}`, color:T.muted, borderRadius:6, padding:"3px 7px", cursor:"pointer", fontSize:14, transition:"all 0.18s", marginLeft:4 },
};
